// Token Refresh Service

import axios from 'axios';
import { clearTokens, getRefreshToken, storeTokens } from '../lib/authUtils';

export class TokenRefreshService {
  private static instance: TokenRefreshService;
  private readonly axiosInstance;

  private constructor() {
    // Create a separate axios instance for token refresh
    const baseURL = this.getBaseUrl();

    this.axiosInstance = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  static getInstance(): TokenRefreshService {
    if (!TokenRefreshService.instance) {
      TokenRefreshService.instance = new TokenRefreshService();
    }
    return TokenRefreshService.instance;
  }

  private getBaseUrl(): string {
    const envBaseUrl = process.env.REACT_APP_API_BASE_URL;
    if (envBaseUrl) {
      return `${envBaseUrl}/api/auth`;
    }
    return `/api/auth`;
  }

  async refreshTokens(): Promise<boolean> {
    try {
      const refreshToken = getRefreshToken();
      if (!refreshToken) {
        clearTokens();
        return false;
      }

      const response = await this.axiosInstance.post('/refresh-session', {
        token: refreshToken,
      });

      const { accessToken, refreshToken: newRefreshToken } = response.data;
      storeTokens(accessToken, newRefreshToken);
      return true;
    } catch (error) {
      console.error('Token refresh failed:', error);
      clearTokens();
      return false;
    }
  }
}

export const tokenRefreshService = TokenRefreshService.getInstance();
